import React from "react";
import { useRouter } from "next/router";
import Turnstile from "react-turnstile";
const TurnstileRecaptcha = ({ onVerify, className = "", ...props }) => {
    const { locale } = useRouter();
    return (
        <Turnstile
            theme="light"
            className={className}
            sitekey={process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY}
            onVerify={(token) => {
                onVerify(token);
            }}
            language={locale}
            {...props}
        />
    );
};
export default TurnstileRecaptcha;
